import NextPreviousAdBreakControl from './NextPreviousAdBreakControl';

// Pass mode into parent function
const NextAdBreakControl = NextPreviousAdBreakControl('next');

NextAdBreakControl.displayName = 'NextAdBreakControl';
export default NextAdBreakControl;
